module.exports = __webpack_public_path__ + "static/img/tecg.80813ab.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/enjoyImg/tecg.png
// module id = /dSD
// module chunks = 119